var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("iframe", {
        staticClass: "radius-5 no-overflow",
        attrs: {
          id: "gFrame",
          src: "https://app.eatself.com/dist/g-button.html",
          xsrc: "http://localhost/eatself/dist/g-button.html",
          frameborder: "0",
          width: "100%",
          height: "103px",
        },
      }),
      _vm._v(" "),
      _c(
        "p",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.LoginStatus,
              expression: "LoginStatus",
            },
          ],
          staticClass: "text-danger text-center",
        },
        [_vm._v(_vm._s(_vm.LoginStatus))]
      ),
      _vm._v(" "),
      _c("ask-mobile-popover", {
        attrs: { mobile: _vm.mobile, "is-open": _vm.openPopover },
        on: { done: _vm.updateMobile },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }